/* Company Confidential, Copyright (c) 2017 CRF Box, Ltd. All Rights Reserved. */

export const ACTIVITY_TYPE_LABELS = {
  LI: 'Logs in',
  SLI: 'Logs in',
  SE: 'Enters section',
  PE: 'Enters page',
  PL: 'Leaves page',
  SD: 'Confirms section',
  LO: 'Logs out',
  FA: 'Confirms flag answered',
  QU: 'Confirms understanding review questions',
  CB: 'Click button',
  SA: 'Starts audio',
  PA: 'Pauses audio',
  EA: 'Finishes audio',
  SV: 'Starts video',
  PV: 'Pauses video',
  FV: 'Finishes video',
  ODP: 'Enters preview mode',
  CDP: 'Leaves preview mode',
  BTLP: 'Back to Landing Page',
  COR: 'Confirms latest opt-in/opt-out response option(s)',
  CPOR: "Confirms participant's latest opt-in/opt-out response option(s)",
  DTS: 'Declines to sign'
};

export const ACTIVITY_TYPE_ICONS = {
  LI: 'description',
  SLI: 'description',
  SE: 'subdirectory_arrow_right',
  PE: 'arrow_forward',
  PL: 'arrow_back',
  SD: 'check_circle',
  LO: 'exit_to_app',
  FA: 'flag',
  QU: 'check_circle',
  CB: 'arrow_back',
  SA: 'play_circle_filled',
  PA: 'pause_circle_filled',
  EA: 'stop_circle',
  SV: 'play_circle_filled',
  PV: 'pause_circle_filled',
  FV: 'stop_circle',
  ODP: 'document_scanner',
  CDP: 'close_fullscreen',
  BTLP: 'keyboard_return',
  COR: 'check_circle',
  CPOR: 'check_circle',
  DTS: 'assignment_late'
};

export const JOURNAL_EVENT_TYPE_ICONS = {
  CONSENTING_STATUS_UPDATE: 'settings',
  CHANGE_ANSWERS_REQUESTED: 'announcement',
  CHANGE_ANSWERS_DISCUSSED: 'chat_bubble',
  CHANGE_ANSWERS_ACCEPTED: 'speaker_notes',
  CHANGE_ANSWERS_CANCELLED: 'speaker_notes_off',
  PARTICIPANT_STATUS_UPDATE: 'settings',
  PARTICIPANT_GENDER_UPDATED: 'settings',
  PARTICIPANT_BIRTHDATE_UPDATED: 'settings',
  PARTICIPANT_ADDRESS_UPDATED: 'settings',
  PARTICIPANT_CREATED: 'person_add',
  CONSENTING_CREATED: 'note_add',
  QUESTION_ANSWERED: 'flag',
  FLAG: 'flag',
  UNFLAG: 'flag',
  SIGNATURE_AFFIRMATION: 'check_box',
  IDENTITY_CHECKED: 'check_box',
  SIGNED: 'assignment_turned_in',
  ABORT_DATA: 'block',
  CHECKS_CHECKBOX_ANSWER: 'check',
  UNCHECKS_CHECKBOX_ANSWER: 'check_box',
  SELECTS_RADIO_BUTTON: 'radio_button_checked',
  DESELECTS_RADIO_BUTTON: 'radio_button_unchecked',
  KNOWLEDGE_CHECK_ANSWER_CORRECT: 'check_circle',
  KNOWLEDGE_CHECK_ANSWER_INCORRECT: 'cancel',
  PARTICIPANT_INFORMATION: 'settings',
  VERSION_REMOVED: 'delete_sweep',
  DOCUMENT_REMOVED: 'delete_sweep',
  VERSION_ADDED: 'note_add',
  PDF_MANUALLY_UPLOADED: 'cloud_upload',
  PDF_MANUALLY_REMOVED: 'delete_sweep',
  ADDENDUM_MANUALLY_UPLOADED: 'cloud_upload',
  ADDENDUM_MANUALLY_REMOVED: 'delete_sweep',
  NOTIFICATION_EMAIL_UPDATED: 'email',
  SIGN_ON_PAPER_CHANGE_ANSWERS: 'question_answer',
  PARTICIPANT_PRIVACY_POLICY_STATUS: 'check_box'
};

export const ICONS_COLORS = {
  LI: 'grey',
  SLI: 'grey',
  SE: 'grey',
  PE: 'grey',
  PL: 'grey',
  SD: 'blue',
  LO: 'grey',
  FA: 'green',
  QU: 'grey',
  CB: 'grey',
  SA: 'blue',
  PA: 'grey',
  EA: 'blue',
  SV: 'blue',
  PV: 'grey',
  FV: 'blue',
  ODP: 'grey',
  CDP: 'grey',
  BTLP: 'grey',
  COR: 'grey',
  CPOR: 'grey',
  DTS: 'red',
  CONSENTING_STATUS_UPDATE: 'grey',
  PARTICIPANT_STATUS_UPDATE: 'grey',
  PARTICIPANT_GENDER_UPDATED: 'grey',
  PARTICIPANT_BIRTHDATE_UPDATED: 'grey',
  PARTICIPANT_ADDRESS_UPDATED: 'grey',
  PARTICIPANT_CREATED: 'grey',
  CONSENTING_CREATED: 'grey',
  QUESTION_ANSWERED: 'green',
  FLAG: 'red',
  UNFLAG: 'green',
  SIGNATURE_AFFIRMATION: 'grey',
  IDENTITY_CHECKED: 'grey',
  SIGNED: 'green',
  ABORT_DATA: 'red',
  CHECKS_CHECKBOX_ANSWER: 'green',
  UNCHECKS_CHECKBOX_ANSWER: 'red',
  SELECTS_RADIO_BUTTON: 'blue',
  DESELECTS_RADIO_BUTTON: 'grey',
  KNOWLEDGE_CHECK_ANSWER_CORRECT: 'green',
  KNOWLEDGE_CHECK_ANSWER_INCORRECT: 'red',
  PARTICIPANT_INFORMATION: 'grey',
  VERSION_REMOVED: 'grey',
  VERSION_ADDED: 'grey',
  PDF_MANUALLY_UPLOADED: 'grey',
  PDF_MANUALLY_REMOVED: 'grey',
  NOTIFICATION_EMAIL_UPDATED: 'grey',
  SIGN_ON_PAPER_CHANGE_ANSWERS: 'grey',
  PARTICIPANT_PRIVACY_POLICY_STATUS: 'green'
};
